class DepartemenEntity {
  id: number;
  departemen: string;

  constructor(object: {
    id: number;
    departemen: string;
  }) {
    this.id = object.id;
    this.departemen = object.departemen;
  }
}

class AddDepartemenEntity {
  departemen?: string;

  constructor(object: {
    departemen?: string;
  }) {
    this.departemen = object.departemen;
  }
}

export { DepartemenEntity, AddDepartemenEntity };